<template>
  <section>
    <h2>Welcome to Coop Finance</h2>
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'FrontofficeHome'
})
</script>

<style scoped>
</style>


